export default "__VITE_ASSET__DHhzyyYd__"